import { type FC } from 'react';
import { Paper, Stack, Text } from '@mantine/core';
import { PayoutTraderStatus, type PayoutTrader } from '~/entities/payout';
import { type ActivateTraderRequest, type UpdateTraderConfigRequest } from '../../model';
import { ActivationForm, TraderConfigForm } from './components';

interface TraderSettingsCardProps {
    configFormKey?: string;
    fallbackTraderId: string;
    isActivatePending: boolean;
    isUpdateConfigPending: boolean;
    onActivate: (values: ActivateTraderRequest) => void;
    onUpdateConfig: (values: UpdateTraderConfigRequest) => void;
    trader?: PayoutTrader;
    traderId?: string;
}

export const TraderSettingsCard: FC<TraderSettingsCardProps> = ({
    configFormKey,
    fallbackTraderId,
    isActivatePending,
    isUpdateConfigPending,
    onActivate,
    onUpdateConfig,
    trader,
    traderId,
}) => {
    const isCreated = trader?.status === PayoutTraderStatus.STATUS_CREATED;
    const effectiveTraderId = traderId ?? fallbackTraderId;

    if (!trader) {
        return (
            <Paper
                p='md'
                radius='md'
                withBorder
            >
                <Text
                    fw={600}
                    size='sm'
                >
                    Настройки
                </Text>
            </Paper>
        );
    }

    if (!isCreated) {
        return (
            <Paper
                p='md'
                radius='md'
                withBorder
            >
                <Stack gap='md'>
                    <Text
                        fw={600}
                        size='sm'
                    >
                        Конфигурация
                    </Text>

                    <TraderConfigForm
                        key={configFormKey}
                        trader={trader}
                        fallbackTraderId={effectiveTraderId}
                        isLoading={isUpdateConfigPending}
                        onSubmit={onUpdateConfig}
                    />
                </Stack>
            </Paper>
        );
    }

    return (
        <Paper
            p='md'
            radius='md'
            withBorder
        >
            <Stack gap='md'>
                <Text
                    fw={600}
                    size='sm'
                >
                    Активация
                </Text>

                {effectiveTraderId && (
                    <ActivationForm
                        traderId={effectiveTraderId}
                        isLoading={isActivatePending}
                        onSubmit={onActivate}
                    />
                )}
            </Stack>
        </Paper>
    );
};
